module.exports = __webpack_public_path__ + "static/media/amenities-main-en.e3c822e9.png";